module.exports = __webpack_public_path__ + "static/media/provider_1X2_gaming.15ee57c2.jpg";